import React from 'react';
import { AccordionItem as BSAccordionItem } from 'react-bootstrap';

export default function AccordionItem({
  children,
  eventKey,
  className = '',
  id = undefined,
}: {
  children: React.ReactNode;
  eventKey: string;
  className?: string;
  id?: string | undefined;
}) {
  return (
    <BSAccordionItem eventKey={eventKey} className={`border-bottom-0 ${className}`} id={id}>
      {children}
    </BSAccordionItem>
  );
}
